// components/ui/selected-location-uganda.tsx
import React from "react";

type UgandaLocationProps = {
  region: string;
  subRegion?: string;
  district: string;
  county: string;
  subcounty: string;
  parish: string;
  village: string;
  address: string;
  latitude: number;
  longitude: number;
};

const SelectedLocationUganda: React.FC<UgandaLocationProps> = ({
  region,
  subRegion,
  district,
  county,
  subcounty,
  parish,
  village,
  address,
  latitude,
  longitude
}) => {
  return (
    <div className="mt-6 p-4 bg-gray-50 border border-gray-200 rounded-lg shadow-sm">
      <h3 className="text-lg font-semibold text-gray-800 mb-3 flex items-center justify-center">
        <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
          <path
            fillRule="evenodd"
            d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
            clipRule="evenodd"
          />
        </svg>
        Location
      </h3>

      <div className="bg-white p-4 rounded-md border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2 text-sm mb-3">
          {/* Region */}
          <div className="text-center p-2 bg-gray-50 rounded">
            <div className="font-medium text-gray-600 text-xs uppercase">
              Region
            </div>
            <div className="text-gray-600 font-semibold">
              {region || "Not selected"}
            </div>
          </div>

          {/* Sub-region (optional) */}
          <div className="text-center p-2 bg-gray-50 rounded">
            <div className="font-medium text-gray-600 text-xs uppercase">
              Sub-region
            </div>
            <div className="text-gray-600 font-semibold">
              {subRegion || "Not selected"}
            </div>
          </div>

          {/* District */}
          <div className="text-center p-2 bg-gray-50 rounded">
            <div className="font-medium text-gray-600 text-xs uppercase">
              District
            </div>
            <div className="text-gray-600 font-semibold">
              {district || "Not selected"}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-2 text-sm">
          {/* County */}
          <div className="text-center p-2 bg-gray-50 rounded">
            <div className="font-medium text-gray-600 text-xs uppercase">
              County
            </div>
            <div className="text-gray-600 font-semibold">
              {county || "Not selected"}
            </div>
          </div>

          {/* Subcounty */}
          <div className="text-center p-2 bg-gray-50 rounded">
            <div className="font-medium text-gray-600 text-xs uppercase">
              Subcounty
            </div>
            <div className="text-gray-600 font-semibold">
              {subcounty || "Not selected"}
            </div>
          </div>

          {/* Parish */}
          <div className="text-center p-2 bg-gray-50 rounded">
            <div className="font-medium text-gray-600 text-xs uppercase">
              Parish
            </div>
            <div className="text-gray-600 font-semibold">
              {parish || "Not selected"}
            </div>
          </div>

          {/* Village */}
          <div className="text-center p-2 bg-gray-50 rounded">
            <div className="font-medium text-gray-600 text-xs uppercase">
              Village
            </div>
            <div className="text-gray-600 font-semibold">
              {village || "Not selected"}
            </div>
          </div>
        </div>

        {region && district && county && subcounty && parish && village && (
          <div className="mt-3 pt-3 border-t border-gray-200 flex flex-col justify-center items-center space-y-2">
            {/* <div>
              <p className="text-sm text-gray-600">
                <span className="font-bold">Full Location:</span>{" "}
                <span className="text-gray-800">
                  {[region, subRegion, district, county, subcounty, parish, village]
                    .filter(Boolean)
                    .join(" → ")}
                </span>
              </p>
            </div> */}
            <div>
              <p className="text-sm text-gray-600">
                <span className="font-bold">Address:</span>{" "}
                <span className="text-gray-800">
                  {address || "Not provided"}
                </span>
              </p>
            </div>
            <div>
              <p className="text-sm text-gray-600">
                <span className="font-bold">Coordinates:</span>{" "}
                <span className="text-gray-800">
                  {latitude && longitude 
                    ? `Lat: ${latitude.toFixed(6)}, Long: ${longitude.toFixed(6)}` 
                    : "Not captured"}
                </span>
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectedLocationUganda;